import { EventTicketsModel } from '@/v2/models/eventTicketsModel';
import { EventProductsModel } from '@/v2/models/eventProductsModel';

export type MultiEventEnvelopeModel = {
  id: number;
  orderId: string | null;
  locatorId: string | null;
  tmOrderUrl: string;
  activeToken: string;
  accessUri: string;
  userLanguage: string;
  eventTickets: EventTicketsModel[];
  eventProducts: EventProductsModel[];
  shouldRedirectToRedemption: boolean;
  redirectToRedemptionOnDesktop: boolean;
  shouldDisplayCompleteFeeBreakdown: boolean;
  envelopeFeeDisplayType: EnvelopeFeeDisplayType;
  redemptionAvailability: RedemptionAvailabilityModel;
  otherFees: number;
  currency: string;
  featureFlags: { [key: string]: boolean };
};

export type RedemptionAvailabilityModel = {
  redemptionDisabled: boolean;
  reason: string;
};

export enum EnvelopeFeeDisplayType {
  ROLLED_UP,
  SINGLE_LINE,
  COMPLETE_BREAKDOWN,
}
